import { createRecipe } from './runtime';

const buttonConfig = {"name":"button","className":"btn","defaultVariants":{"size":"md","tone":"brand","variant":"secondary"},"variantMap":{"size":["lg","md","sm","xs"],"variant":["unstyled","link","secondary","ghost","plain","primary","solid","outline","neutral","toolbar","sidebar"],"tone":["brand","danger","red"]}}

export const button = /* @__PURE__ */ createRecipe(buttonConfig)